// export const apiEndpointGet = 'https://test.zsl-dgse.w11k.app/api/dgse_1_1/get_courses_for_school_and_year';
// export const apiEndpointPost = 'https://test.zsl-dgse.w11k.app/api/dgse_1_1/add_classwork';

// export const apiEndpointGet = 'https://dgse.oes-bw.de/api/dgse_1_1/get_courses_for_school_and_year';
// export const apiEndpointPost = 'https://dgse.oes-bw.de/api/dgse_1_1/add_classwork';

// env variables are baked into build
// workarounds:
// use runtime loaded config, i.e. config.json
// inject env vars dynmically from server into docker container before starting
// or
// use a cookie - injected by proxy on request - (let's try that one)

import { getCookie } from "./Functions";
const apiBaseUrl = getCookie("API_ENDPOINT_URL") || "dgse.oes-bw.de";

export const apiEndpointGet = `https://${apiBaseUrl}/api/dgse_1_1/get_courses_for_school_and_year`;
export const apiEndpointPost = `https://${apiBaseUrl}/api/dgse_1_1/add_classwork`;

export const default_toast_showtime = 5000;
export const default_tooltip_show = 150;
export const default_tooltip_hide = 100;
export const default_tooltip_maxwidth = "500px";
export const default_tooltip_width = "300px";

export const default_load_button_info_tooltip_timeout = 3000;

export const fontFamily = '"Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif';

// text work
export const strToolNameHeadline = "DGSE Klassenarbeiten - Analyse und Dokumentation"
export const strToolName = "Unterrichtsentwicklung mit Ergebnissen von Klassenarbeiten";

export const title_evaluation = "Klassenarbeiten bzw. Klassenarbeiten analysieren";
export const title_evaluation_save = "Ihren aktuellen Analysestand speichern";
export const title_evaluation_load = "Einen gespeicherten Analysestand laden";
export const title_analysis = "Klassenarbeiten bzw. Klassenarbeiten analysieren";
export const title_analysis_export = "Dokumentation für die Schulentwicklung in der DGSE Datenbank speichern";
export const title_exams = "Klassenarbeiten laden";

export const criteria = [
    "Durchschnittlicher Lösungsgrad in einer Klasse",
    "Abstand der Lösungsgrade in einer Klasse",
    "Unterschied im Lösungsgrad zwischen mehreren Klassen"
];

export const criteria_tooltips = [
    // "Der durchschnittliche Lösungsgrad einzelner Aufgaben unterschreitet 20% und/oder überschreitet 80%.",
    "Der durchschnittliche Lösungsgrad einzelner Aufgaben unterschreitet 20% oder überschreitet 80%.",
    "Der Lösungsgrad der Aufgaben untereinander überschreitet 40%.",
    "Der relative Abstand einzelner Aufgaben überschreitet 20%."
];

export const filename_download_checklist = "Checkliste_Lernergebnisse.pdf";
export const str_no_exams_available = "Sie haben noch keine Klassenarbeit im System hinterlegt.";

// nav helpers
export const linkTriggerExamLoad = "/auswertung/klassenarbeiten?trigger=load";
export const linkTriggerEvaluationLoad = "/auswertung/auswertung/laden?trigger=load";

export const linkOESDGSE = "https://www.schule-bw.de/themen-und-impulse/oes/02-dgse/index.html";
export const linkDPImprint = "/?open=";

